<template>
  <div class="nav">
    <div class="trade">
      <h5 @click="flag=!flag">The 21st China International Petroleum & Petrochemical Technology and Equipment Exhibition
        <img src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/icon/app_down.png" alt=""/>
      </h5>
      <ul class="navUL" v-show="flag">
        <li>
          <span>Exhibition Time:</span>
          <span>2021.6.8-6.10</span>
        </li>
        <li>
          <span>Exhibition Address:</span>
          <span>Beijing. New China International Exhibition Center</span>
        </li>
        <li>
          <span>Organizer:</span>
          <span>Zhenwei Exhibition Group</span>
        </li>
        <li>
          <span>Organizing Committee:</span>
          <span>Beijing Zhenwei Exhibition Co.,Ltd.</span>
        </li>
      </ul>
    </div>
    <ul class="navList">
      <li @click="()=>this.appHerf('https://en.cippe.com.cn/about-introduction/')">
        <img src="http://www.cippe.com.cn/miniprogram/navbg01.png" alt=""/>
        <p>General Introduction</p>
      </li>
      <li @click="()=>this.appHerf('https://xzt.eastfair.com/syshydjEN/page/login.html?ExhID=1453')">
        <img src="http://www.cippe.com.cn/miniprogram/navbg02.png" alt=""/>
        <p>Get Ticket</p>
      </li>
      <li @click="()=>this.$router.push('/home/planning')">
        <img src="http://www.cippe.com.cn/miniprogram/navbg03.png" alt=""/>
        <p>Exhibition Hall Layout</p>
      </li>
      <li @click="()=>this.$router.push('/home/activities')">
        <img src="http://www.cippe.com.cn/miniprogram/navbg04.png" alt=""/>
        <p>Concurrent Activities</p>
      </li>
      <!-- <li @click="()=>this.$router.push('/supply')">
        <img src="http://www.cippe.com.cn/miniprogram/navbg05.png" alt=""/>
        <p>供需对接</p>
      </li> -->
    </ul>
  </div>
</template>

<script>
export default {
  data () {
    return {
      flag:false,
    }
  }
}
</script>

<style scoped>
  img{
    width: 100%;
  }
  .nav{
    margin-left: -10px;
    margin-right: -10px;
    padding: 10px;
    background-color: white;
    
  }
  .trade h5{
    color: #000;
    font-weight: 600;
    font-size: 13px;
    line-height: 25px;
  }
  .trade h5 img{
    float: right;
    width: 18px;
  }
  .navUL{
    padding: 15px 0 10px;
    font-size: 12px;
  }
  .navUL li{
    padding: 5px 0;
    border-bottom: 1px solid rgba(0, 0, 0, .1);
    color: #808080;
  }
  .navList{
    width: 100%;
    padding-top: 20px;
    display: flex;
    justify-content: space-between;
  }
  .navList li{
    display: inline-block;
    box-sizing: border-box;
    padding: 0 9px;
    width: 20%;
    text-align: center;
  }
  .navList li img{
    width: 100%;
    height: auto;
    border-radius: 50%;
    font-size: 12px;
  }
  .navList li p{
    padding-top: 20px;
    font-size: 12px;

  }
</style>